import { buyerHasOffer } from 'components/card/Buyers/Helpers';
import { MKT_STATUS_TYPE } from 'helpers/marketplaceStatus';
import { isAuctionEngineVehicle, isExpired, isSold } from 'helpers/vehicle';
import getSoldOfferStatus from '../sold';

const getEndedOfferStatus = ({ vehicle, currentUserTopOfferer }) => {
	if (isAuctionEngineVehicle(vehicle)) {
		if (isSold(vehicle)) {
			return getSoldOfferStatus({ vehicle, currentUserTopOfferer });
		} else {
			if (buyerHasOffer(vehicle)) {
				return { unifiedStatusType: MKT_STATUS_TYPE.lost };
			} else {
				if (isExpired(vehicle)) return { unifiedStatusType: MKT_STATUS_TYPE.expired };
			}
		}
	}

	return { unifiedStatusType: MKT_STATUS_TYPE.expired };
};

export default getEndedOfferStatus;
